<template>
    <div class="wizard__wrap wizard__wrap--invoices">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">{{ agencyName }}</div>
            </div>

            <div class="wizard__block-title" style="font-size: 20px">
                Did you invoice for any new services <br />
                or one time fees without a new SOW for {{ getCurrentDealName }}?
            </div>

            <div class="wizard__block-sow">
                <div class="row jus-c--center">
                    <div class="col-lg-12 col-md-12">
                        <div
                            class="form-field form-field--radiobutton"
                            style="text-align: center"
                        >
                            <input
                                type="radio"
                                name="is_has_new_sow"
                                id="is_has_new_sow_yes"
                                :checked="isHasNewSow"
                                @change="isHasNewSow = true"
                            />
                            <label style="width: 70px" for="is_has_new_sow_yes"
                                >Yes</label
                            >
                        </div>
                        <div
                            class="form-field form-field--radiobutton"
                            style="text-align: center"
                        >
                            <input
                                type="radio"
                                name="is_has_new_sow"
                                id="is_has_new_sow_no"
                                :checked="isHasNewSow === false"
                                @change="isHasNewSow = false"
                            />
                            <label style="width: 70px" for="is_has_new_sow_no"
                                >No</label
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button @click="onPrevPage" class="btn btn--prev btn--white">
                    Previous
                </button>
                <button @click="onNextPage" class="btn btn--prev btn--white">
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { SECTIONS } from "../consts";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Do_You_Have_New_Upsell",
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isHasNewUpsell: null,
            isHasNewSow: null,
        };
    },

    mounted() {
        scrollToTop();
    },

    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        isEditUpsell() {
            return this.$store.getters.getIsEditUpsell;
        },
        getCurrentDealId() {
            return (
                this.$store.getters.getSalesPages(
                    this.$store.getters.getDealSalesIndex
                ).deal_id || null
            );
        },
        getCurrentDealName() {
            return (
                this.$store.getters.getSalesPages(
                    this.$store.getters.getDealSalesIndex
                ).deal_name || null
            );
        },
        sowIndex() {
            return this.$store.getters.getCurrentIndexSOW;
        },
        isEditUpsell() {
            return this.$store.getters.getIsEditUpsell;
        },
    },

    methods: {
        async getSOWTitle() {
            let __title = "";

            await axios
                .post("/api/wizard/getList", {
                    page: "new_sow",
                    deal_id: this.getCurrentDealId,
                    sow_index: this.isEditUpsell
                        ? this.sowIndex
                        : this.sowIndex + 1,
                })
                .then((res) => {
                    __title = res.data.page.sow_title;
                });

            return __title;
        },
        onNextPage() {
            if (this.isHasNewSow === undefined || this.isHasNewSow === null) {
                this.$toast.error("Please select an answer");
                return;
            }

            const salesPages = this.$store.getters.getSalesPages(
                this.$store.getters.getSalesPagesIndex + 1
            );

            if (this.isEditUpsell) {
                if (this.isHasNewUpsell) {
                    this.onChangeSection(
                        SECTIONS.SOW,
                        SECTIONS.DO_YOU_HAVE_UPSELL
                    );
                    return;
                } else {
                    this.onChangeSection(
                        SECTIONS.UPSELL,
                        SECTIONS.DO_YOU_HAVE_UPSELL
                    );
                }
                return;
            }

            if (this.isHasNewUpsell) {
                this.onChangeSection(SECTIONS.SOW, SECTIONS.DO_YOU_HAVE_UPSELL);
                return;
            }

            if (!this.isHasNewUpsell && this.isHasNewSow) {
                this.$store.commit("setIsWithoutSOW", true);
                this.onCreateSOWWithoutUpsell();
                return;
            }

            if (this.isHasNewSow) {
                this.$store.commit("setIsWithoutSOW", true);
                this.onCreateSOWWithoutUpsell();
                return;
            } else {
                if (salesPages) {
                    this.$store.commit(
                        "setSalesPagesIndex",
                        this.$store.getters.getSalesPagesIndex + 1
                    );

                    this.$store.commit("incrementDealIndex");
                    this.$store.commit("setSaleIndex", 0);

                    this.onChangeSection(
                        SECTIONS.EDIT_SALE_LINE_ITEM,
                        SECTIONS.DASHBOARD
                    );
                    return;
                } else {
                    this.onChangeSection(
                        SECTIONS.INVOICES,
                        SECTIONS.DO_YOU_HAVE_UPSELL
                    );
                }
            }
        },
        onPrevPage() {
            this.onChangeSection(
                SECTIONS.DO_YOU_HAVE_UPSELL,
                SECTIONS.DO_YOU_HAVE_SERVICE_WITHOUT_SOW
            );
        },

        async onCreateSOWWithoutUpsell() {
            let sow_title = (await this.getSOWTitle()) || "";

            let currentDate = moment();
            let pastMonthDate = currentDate.subtract(1, "months");
            pastMonthDate.startOf("month");
            let formattedDate = pastMonthDate.format("MM/DD/YYYY");

            const data = {
                name: sow_title,
                date: formattedDate,
                url: "",
                description: "I don’t have signed SOW",
                deal_id: this.getCurrentDealId,
                type: "none",
                is_file: false,
                valid_date: null,
                sow_index: this.isEditUpsell
                    ? this.sowIndex
                    : this.sowIndex + 1,
            };

            const formData = new FormData();

            formData.append("action", "createSow");
            formData.append("data", JSON.stringify(data));
            // formData.append("file", null);

            axios
                .post("api/wizard/updateDraft", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(() => {
                    if (!this.isEditUpsell) {
                        this.$store.commit("setIndexSOW", this.sowIndex + 1);
                        this.$store.commit(
                            "setIndexUpsell",
                            this.upsellIndex + 1
                        );
                    }
                    this.onChangeSection(
                        SECTIONS.UPSELL,
                        SECTIONS.DO_YOU_HAVE_UPSELL
                    );
                })
                .catch((err) => {
                    this.$toast.error("Something went wrong!");
                    console.log("ERROR addSOWFile", err);
                });
        },
    },
};
</script>
